import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CardTextInfo} from '../models/card_textsmaster';
import {CardTextsService} from '../services/card_texts.service';
import {ActivatedRoute, Router} from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-addcard_texts',
    templateUrl: './addcard_texts.component.html'
})
export class AddcardTextsComponent implements OnInit {
    title: string = 'Add Card Text';
    card_texts_id = 0;
    cardtextform: FormGroup;
    cardtextinfo: CardTextInfo;
    card_id: number = 0;
    public allcategories = [];
    public selectedValue;
    public catvalue;
    public pages = [];
    isEdit: boolean = false;
    ckeditorContent;

    constructor(
        private cardTextsService: CardTextsService,
        private router: Router,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
    ) {
        activatedRoute.params.subscribe(params => {
            this.card_texts_id = params['id'];
            if (params['cardid']) {
                this.card_id = params['cardid'];
                console.log('CardId======>', this.card_id); // Print the parameter to the console.
            }
        });
        if (this.card_texts_id > 0) {
            this.isEdit = true;
        }
        if (this.card_texts_id > 0) {
            this.title = 'Edit Card Text';
        }
    }

    ngOnInit() {
        /*this.title;
        this.isEdit;*/
        this.cardtextform = this.fb.group({
            font_size: ['',
                Validators.required
            ],
            x: ['',
                Validators.required
            ],
            card_id: [],
            height: ['',
                Validators.required
            ],
            y: ['',
                Validators.required
            ],
            width: ['',
                Validators.required
            ],
            text: ['',
                Validators.required
            ],
            alignment: ['',
                Validators.required
            ],
            character_spacing: ['',
                Validators.required
            ],
            font: ['',
                Validators.required
            ],
            text_color: ['',
                Validators.required
            ],
            line_spacing: ['',
                Validators.required
            ],
            number_of_line: ['',
                Validators.required
            ],
        });

        if (this.isEdit) {
            this.getCardTextInfo();
        } else {
            this.cardtextform.patchValue({
                card_id: this.card_id,
            });

        }

        // this.loadScriptLibrary();
    }

    onSubmit(cardValue) {

        if (this.isEdit) {
            this.updateForm(cardValue);
        } else {
            this.addForm(cardValue);
        }
    }

    addForm(cardTextsValue) {
        debugger
        $('#save_card').button('loading');
        this.cardTextsService.createCardText(cardTextsValue).then(CardTextData => {
            if (CardTextData['code'] === 200) {
                $('#save_card').button('reset');
                $.toast({
                    heading: 'Success',
                    text: CardTextData['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'success'
                });
                this.router.navigate(['/cards/cardtexts/' + cardTextsValue['card_id']]);
            } else {
                $.toast({
                    heading: 'Warning',
                    text: CardTextData['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'warning'
                });
                $('#save_card').button('reset');
            }
        }).catch(err => {
            if (err['code'] !== 200) {
                $.toast({
                    heading: 'Error',
                    text: err['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'error'
                });
            } else {
                $.toast({
                    heading: 'Error',
                    text: 'Server error! Please try again later',
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'error'
                });
            }
            $('#save_card').button('reset');
        });
    }

    updateForm(cardTextsValue) {
        $('#update_card').button('loading');
        cardTextsValue['card_texts_id'] = this.card_texts_id;
        this.cardTextsService.updateCardText(cardTextsValue).then(CardTextData => {
            if (CardTextData['code'] === 200) {
                $('#update_card').button('reset');
                $.toast({
                    heading: 'Success',
                    text: CardTextData['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'success'
                });
                this.router.navigate(['/cards/cardtexts/' + cardTextsValue['card_id']]);
            } else {
                console.log(CardTextData['message']);
                $.toast({
                    heading: 'Warning',
                    text: CardTextData['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'warning'
                });
                $('#update_card').button('reset');
            }
        }).catch(err => {
            if (err['status'] !== 200) {
                $.toast({
                    heading: 'Error',
                    text: err['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'error'
                });
            } else {
                $.toast({
                    heading: 'Error',
                    text: 'Server error! Please try again later',
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'error'
                });
            }
            $('#update_card').button('reset');
        });
    }

    getCardTextInfo = function () {
        this.cardTextsService.getCardTextInfo(this.card_texts_id).then(data => {
            console.log('CardTextInfo11=======>', data['data']);
            this.cardtextinfo = data['data'];
            this.patchForm();
        });


    }

    patchForm() {
        console.log('CardTextInfoDetails=======>' + this.cardtextinfo)
        this.cardtextform.patchValue({
            card_id: this.cardtextinfo.card_id,
            font_size: this.cardtextinfo.font_size,
            x: this.cardtextinfo.x,
            height: this.cardtextinfo.height,
            y: this.cardtextinfo.y,
            width: this.cardtextinfo.width,
            text: this.cardtextinfo.text,
            alignment: this.cardtextinfo.alignment,
            character_spacing: this.cardtextinfo.character_spacing,
            font: this.cardtextinfo.font,
            text_color: this.cardtextinfo.text_color,
            line_spacing: this.cardtextinfo.line_spacing,
            number_of_line: this.cardtextinfo.number_of_line,
        });
    }

    public loadScriptLibrary() {
        let body = <HTMLDivElement> document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/adminlte/plugins/ckeditor/ckeditor.js';
        body.appendChild(script);

        let body2 = <HTMLDivElement> document.body;
        let script2 = document.createElement('script');
        script2.innerHTML = 'CKEDITOR.replace( \'tDescription\' );';
        body2.appendChild(script2);
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/card_textsmaster/addcard_texts/addcard_texts.component.ts